import React from 'react'
import TreatmentPlanHistory from '@components/pages/Charting/TreatmentPlan/TreatmentPlanHistory.component'

interface HistoryPageProps {
  onViewNote?: (id: string) => void
  onGoToPlans?: () => void
}

const HistoryPage: React.FC<HistoryPageProps> = ({
  onViewNote,
  onGoToPlans,
}): React.ReactElement => {
  return (
    <TreatmentPlanHistory onViewNote={onViewNote} onGoToPlans={onGoToPlans} />
  )
}

export default HistoryPage
